// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import PancardDetailsActionType from './pancard-details.types';

const INITIAL_STATE = {
	// pancard response
	updatePancardResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** Pancard Update Start ************************/
		case PancardDetailsActionType.UPDATE_PANCARD_SUCCESS:
			return { ...state, updatePancardResponse: action.payload };

		case PancardDetailsActionType.UPDATE_PANCARD_FAILURE:
			return { ...state, updatePancardResponse: action.payload };

		case PancardDetailsActionType.UPDATE_PANCARD_RESPONSE_CHANGED:
			return { ...state, updatePancardResponse: null };

		/** ***************** Pancard Update End ************************/
		default:
			return state;
	}
};
